module.exports = __webpack_public_path__ + "img/Borussia_Dortmund_logo.ab8451f8.png";